import moengageWrapper from '../utils/moengage';

moengageWrapper.init();

if (typeof window !== 'undefined') {
    window.vumedi = window.vumedi || {};
    if (!window.vumedi.moengage) {
        Object.defineProperty(window.vumedi, 'moengage', {
            value: moengageWrapper,
            writable: false,
            configurable: false,
            enumerable: true,
        });
    }
}
